<template>
  <div class="nft-type-filter-comp">
    <div class="tab-list">
      <div
          v-for="(filter, index) in filterList"
          :key="index"
          class="tab-item cursor-pointer"
          @click="changeType(filter.value as NftCtgy)"
      >
        <mv-tab
            :content="filter"
            :selected="cltnType === filter.value"
            type="text"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import MvTab from '@/components/common/tab/MvTab.vue';
import {useDiscoverListTypeConfig} from '@/script/discover/discoverScript';
import {NftCtgy} from '@/models/types';

export default defineComponent({
  name: 'NftTypeFilterComp',
  components: {
    MvTab,
  },
  setup() {
    const {
      changeType,
      cltnType,
    } = useDiscoverListTypeConfig()
    const filterList = [
      {
        label: 'nftType.all',
        value: ''
      },
      {
        label: 'nftType.TICKET',
        value: 'TICKET',
      },
      {
        label: 'nftType.MEMBERSHIP',
        value: 'MEMBERSHIP',
      },
    ]

    return {
      filterList,
      cltnType,
      changeType,
    }
  }
})
</script>
